import React from 'react'

import { Col } from '../../packages/kiti/components/structure/Grid'
import Center from '../../packages/kiti/components/helpers/Center'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Panel from '../../packages/kiti/components/structure/Panel'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text from '../../packages/kiti/components/presentation/Text'

const commonPanelProps = {
  noPadding: true,
  width: 2.5,
  height: 2.5,
  justify: 'center',
  align: 'center'
}

const Pagination = ({ onChange, page }) => {
  const leftDisabled = page === 1

  return (
    <>
      <Separator weight={4} />
      <Center gap={0.4}>
        <Col>
          <Panel
            {...commonPanelProps}
            onClick={!leftDisabled ? () => onChange(page - 1) : undefined}
            bgColor={!leftDisabled ? 'primary' : 'light4'}
          >
            <Icon name="BsArrowLeftShort" color="white" />
          </Panel>
        </Col>
        <Col>
          <Panel {...commonPanelProps} gColor="light2">
            <Text size="h6">{page}</Text>
          </Panel>
        </Col>
        <Col>
          <Panel {...commonPanelProps} onClick={() => onChange(page + 1)} bgColor="primary">
            <Icon name="BsArrowRightShort" color="white" />
          </Panel>
        </Col>
      </Center>
    </>
  )
}

export default Pagination
